import { createCollectionReducer } from "reducers/account/collections";
import { getCacheKey } from "utils/caching";

const TYPE = "analyticsV2";
export default createCollectionReducer(TYPE);
export const selectAccountAnalytics = (state, query = {}) => {
  const cacheKey = getCacheKey(query);
  const analytics = state.account[TYPE][cacheKey] || {};
  const { results } = analytics;
  return results;
};
